export default "__VITE_ASSET__BHGmql$7__"